export default __webpack_public_path__ + "static/media/happyFace.8f0cef96.svg";